import React from 'react';

import './style.sass';

const ContentCaseMiddle = ({ listTitle }) => {
    return (
        <div className="content-case__middle">
            {listTitle[0].description ? (
                <div className="content-case__wrapper">
                    {listTitle[0].description.map((items, idx) => (
                        <div className="content-case__wrapper-item" key={idx}>
                            <div
                                className="content-case__wrapper-name"
                                dangerouslySetInnerHTML={{ __html: items.name }}
                            />
                            <div
                                className="content-case__wrapper-details"
                                dangerouslySetInnerHTML={{ __html: items.details }}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                ''
            )}
        </div>
    );
};
export default ContentCaseMiddle;
